import API_ENDPOINTS from "app/config/endpoints";
import axios from "axios";
const AUTH_BASE = process.env.REACT_APP_AUTH_BASE;
// Get Auth Access Token from localstorage
const authAccessToken = localStorage.getItem("authAccessToken");

// get School Access token from localstorage
const schoolAccessToken = localStorage.getItem("schoolToken");
const counselorAccessToken = localStorage.getItem("counselorAccessToken");
export const schoolTokenAxios = axios.create({});
export const authTokenAxios = axios.create({});
export const counselorTokenAxios = axios.create({});

// set Axios header with previous access tokens
if (authAccessToken) {
  authTokenAxios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${authAccessToken}`;
}

if (schoolAccessToken) {
  schoolTokenAxios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${schoolAccessToken}`;
}
if (counselorAccessToken) {
  counselorTokenAxios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${counselorAccessToken}`;
}

authTokenAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;
      const refreshResponse = await axios.post(
        API_ENDPOINTS.auth.refreshToken,
        {
          refreshToken: localStorage.getItem("authRefreshToken"),
          // refreshToken: localStorage.getItem("authRefreshToken"),
        }
      );
      prevRequest.headers[
        "Authorization"
      ] = `Bearer ${refreshResponse.data.accessToken}`;

      authTokenAxios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${refreshResponse.data.accessToken}`;

      localStorage.setItem(
        "authRefreshToken",
        refreshResponse.data.refreshToken
      );

      return authTokenAxios(prevRequest);
    }
    return Promise.reject(error);
  }
);

schoolTokenAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;
    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;
      const refreshResponse = await axios.get(
        API_ENDPOINTS.auth.schoolRefreshToken,
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("schoolRefreshToken"),
          },
        }
      );
      prevRequest.headers[
        "Authorization"
      ] = `Bearer ${refreshResponse.data.obj.accessToken}`;

      schoolTokenAxios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${refreshResponse.data.obj.accessToken}`;

      localStorage.setItem(
        "shoolRefreshToken",
        refreshResponse.data.obj.refreshToken
      );

      return schoolTokenAxios(prevRequest);
    }
    return Promise.reject(error);
  }
);

counselorTokenAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;
    console.log("error", error);
    if (error?.response?.status === 401 && !prevRequest?.sent) {
      prevRequest.sent = true;
      const refreshResponse = await axios.get(
        `${AUTH_BASE}/access/getSchoolCounselorRefreshToken`,
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("counselorRefreshToken"),
            // "Bearer " + localStorage.getItem("counselorAccessToken"),
          },
        }
      );
      prevRequest.headers[
        "Authorization"
      ] = `Bearer ${refreshResponse.data.obj.counselorAccessToken}`;

      counselorTokenAxios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${refreshResponse.data.obj.counselorAccessToken}`;

      localStorage.setItem(
        "counselorRefreshToken",
        refreshResponse.data.obj.counselorRefreshToken
      );

      return counselorTokenAxios(prevRequest);
    }
    return Promise.reject(error);
  }
);
